<div mat-dialog-title>
    <div class="d-flex flex-row">
      <h1 class="form-title-heading flex-grow-1">{{title ? title : 'View Detail'}}</h1>
      <a (click)="this.close()" class="clickable ms-3">
        <img src="/assets/cancel-icon-alt.png" alt="cancel-icon" />
      </a>
    </div>
</div>


<div mat-dialog-content class="row">
  <div class="col-12 col-md-12">
      <table class="table table-borderless table-responsive">
          <tbody>
              <ng-container *ngFor="let key of dialogDataFields">
                  <ng-container  *ngFor="let item of dataArr">
                      <tr *ngIf="item[key.fieldName] && !key.html && !key.attachment && !key.statusField && !key.tableView && !key.isDate  && !key.isTitleOnly && !key.tableView">
                          <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                          <td scope="row" class="colon">:</td>
                          <td scope="row" class="ps-lg-5 break">
                              {{item[key.fieldName] ? item[key.fieldName] : 'N/A'}}</td>
                      </tr>
                      <tr *ngIf="item[key.fieldName] && !key.html && key.attachment && !key.statusField && !key.tableView && !key.isDate  && !key.isTitleOnly && !key.tableView">
                        <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                        <td scope="row" class="colon">:</td>
                        <td scope="row" class="ps-lg-5 break">
                            <a (click)="previewImage(item[key.fieldName])" class="image-link clickable">
                                <div class="d-flex flex-row justify-content-start align-self-center">
                                  <img src="{{assetsPathUrl}}{{item[key.fieldName] ? item[key.fieldName] : 'N/A'}}" alt="Image" style="width: 25px; height: 25px; object-fit: contain;">
                                </div>
                              </a>
                        </td>
                      </tr>
                      <tr *ngIf="item[key.fieldName] && !key.html && !key.attachment && !key.statusField && !key.tableView && key.isDate  && !key.isTitleOnly && !key.tableView">
                        <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                        <td scope="row" class="colon">:</td>
                        <td scope="row" class="ps-lg-5 break">
                            {{item[key.fieldName] | date: 'mediumDate'}}</td>
                      </tr>
                      <tr *ngIf="item[key.fieldName] && key.html && !key.attachment && !key.statusField && !key.tableView && !key.isDate && !key.isTitleOnly && !key.tableView">
                        <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                        <td scope="row" class="colon">:</td>
                        <td scope="row" class="ps-lg-5 break">
                          <span class="status" [ngClass]="item[key.fieldName] | lowercase" [innerHtml]="item[key.fieldName] ? item[key.fieldName] : 'N/A'"></span>
                        </td>
                      </tr>
                      <tr *ngIf="item[key.fieldName] && !key.html && !key.attachment && key.statusField && !key.tableView && !key.isDate && !key.isTitleOnly && !key.tableView">
                        <td scope="row" class="headings">{{key.label ? key.label : ''}}</td>
                        <td scope="row" class="colon">:</td>
                        <td scope="row" class="ps-lg-5 break">
                          <span class="status" [ngClass]="item[key.fieldName].trim() | lowercase" [innerHtml]="item[key.fieldName] ? item[key.fieldName] : 'N/A'"></span>
                        </td>
                      </tr>
                      <tr *ngIf="!item[key.fieldName] && !key.html && !key.attachment && !key.statusField && !key.tableView && !key.isDate && key.isTitleOnly && !key.tableView">
                        <td scope="row" class="headings sub-section" colspan="3">{{key.label ? key.label : ''}}</td>
                      </tr>
                  </ng-container>                  
              </ng-container>
          </tbody>
      </table>
  </div>
  <div class="col-md-12">
   
    <ng-container *ngFor="let key of dialogDataFields">
      <ng-container *ngFor="let item of dataArr">
        <ng-container *ngIf="item[key.fieldName] && key.tableView && key.tableDataFields && key.tableDataFields.length > 0 && key.tableData && key.tableData.length > 0">
          <div class="col-12 col-md-12">
            <h1 class="form-title-heading">{{key.label ? key.label : ""}}</h1>
            <intrasense-table-ui 
              [dataFields]="key.tableDataFields" 
              [dataSource]="key.tableData">
            </intrasense-table-ui>
          </div>
        </ng-container>
      </ng-container>
  </ng-container>
  </div>
  <div class="col-md-12" *ngIf="modalActions">
    <div mat-dialog-actions *ngIf="modalActions.length" class="text-end justify-content-end mt-5">
      <button
        *ngFor="let btn of modalActions"
        class="mat-focus-indicator btn-large ml-2 btn-primary mat-flat-button mat-button-base"
        (click)="btnClickHandler($event)"
        [ngClass]="btn.cssClass" [hidden]="!btn.displayStatus">
        {{ btn.label }}
      </button>
    </div>

  </div>



  <!-- <ng-container *ngFor="let key of dialogDataFields">
    <ng-container *ngFor="let item of dataArr">
      <ng-container *ngIf="item[key.fieldName] && key.tableView && key.tableDataFields && key.tableData">
        <div class="col-12 col-md-12 mb-50">
          <h1 class="form-title-heading-2">{{key.label ? key.label : ""}}</h1>
          <intrasense-table-ui 
            [dataFields]="key.tableDataFields" 
            [dataSource]="key.tableData">
          </intrasense-table-ui>
        </div>
      </ng-container>
    </ng-container>
</ng-container> -->
</div>